import DayForecast from "./DayForecast";

const Forecast = (props) => {
  const allowedCodes = new Set(["1DA", "GND", "2DA", "3DS"]);
  const normalizeUpsName = (name = "") =>
    name.replace(/®/g, "").replace(/\s+/g, " ").trim().toLowerCase();

  const upsTrimmed = (Array.isArray(props.ups) ? props.ups : []).filter(
    (service) => {
      const code = service?.Service?.Code;
      const normalizedName = normalizeUpsName(
        service?.Service?.Description || service?.service || ""
      );
      return (
        allowedCodes.has(code) ||
        normalizedName.includes("next day air") ||
        normalizedName.includes("2nd day air") ||
        normalizedName.includes("second day air") ||
        normalizedName.includes("3 day select") ||
        normalizedName.includes("ground")
      );
    }
  );

  return (
    <div className="max-w-full max-h-max md:mx-0 overflow-x-auto bg-white mx-10 mb-10 ">
      <div className="flex items-center space-x-5  p-10 pb-12 rounded-2xl justify-start md:justify-center ">
        {(Array.isArray(props.weather) ? props.weather : []).map((day, i) => {
          if (!day?.temp || !day?.weather?.[0]) {
            return null;
          }

          let date = new Date();
          date.setDate(date.getDate() + i);

          return (
            <DayForecast
              high={day.temp.max}
              low={day.temp.min}
              conditions={day.weather[0].main}
              icon={day.weather[0].icon}
              day={i}
              services={props.services}
              key={i}
              date={date}
              user={props.user}
              ups={upsTrimmed}
              tempUnit = {props.tempUnit}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Forecast;
